import script from "./DefaultButton.vue?vue&type=script&setup=true&lang=js"
export * from "./DefaultButton.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__